export const Props = () => ({
  //--------------------------------------------------------------------------
  //            Имя Иконки (trend, top, loser, market, trend_nft)
  //--------------------------------------------------------------------------
  iconName: {
    type: String,
    default: 'trend',
    validator: (value) => {
      const allowedTypes = ['trend', 'top', 'loser', 'market', 'trend_nft'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'iconName' в компоненте SectionTitle (Widget Search) может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                            Дополнительный текст
  //----------------------------------------------------------------------------
  prefix: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                            Дополнительный текст
  //----------------------------------------------------------------------------
  isJustify:{
    type: Boolean,
    default: false,
    required: false,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});